// Shared overlay colors for modal backgrounds and hover states
// Import: import { overlays } from '@/theme';

export const overlays = {
  // Standard modal/dialog backdrop
  light: 'rgba(0, 0, 0, 0.5)',

  // Light dim for a small compact confirm (Q-530): the page stays readable
  dim: 'rgba(0, 0, 0, 0.25)',

  // Darker overlay for image previews, confirmations
  dark: 'rgba(0, 0, 0, 0.7)',

  // Card hover overlay (draft cards)
  card: 'rgba(0, 0, 0, 0.288)',

  // Avatar editor hover overlay
  avatar: 'rgba(0, 0, 0, 0.4)',

  // Delete confirmation overlay
  confirm: 'rgba(0, 0, 0, 0.6)',

  // White overlays for dark backgrounds
  whiteFaint: 'rgba(255, 255, 255, 0.1)',
  whiteLight: 'rgba(255, 255, 255, 0.2)',
} as const;
